import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/common';
import SupplierForm from '../SupplierForm';
import { useUIStore } from '@/store/uiStore';
import { toast } from '@/store/toastStore';
import { supplierApi } from '@/api/endpoints/suppliers';
import { UpdateSupplierRequest } from '@/types/supplier';

interface EditSupplierModalProps {
  onSuccess?: () => void;
}

const EditSupplierModal: React.FC<EditSupplierModalProps> = ({
  onSuccess,
}) => {
  const { t } = useTranslation();
  const { modals, closeModal, editingSupplier } = useUIStore();
  const [loading, setLoading] = useState(false);

  const isOpen = modals.editSupplier;

  const handleSubmit = async (data: UpdateSupplierRequest) => {
    if (!editingSupplier?.code) {
      toast.error('Error', 'No supplier selected for editing');
      return;
    }

    console.log('Updating supplier:', editingSupplier.code, data);
    setLoading(true);
    try {
      const result = await supplierApi.updateSupplier(editingSupplier.code, data);
      console.log('Update result:', result);

      toast.success('Success', t('suppliers.updateSuccess'));
      closeModal('editSupplier');

      // Call success callback if provided, otherwise emit a custom event
      if (onSuccess) {
        onSuccess();
      } else {
        // Emit custom event to refresh supplier list
        window.dispatchEvent(new CustomEvent('supplier-updated'));
      }

    } catch (error: any) {
      console.error('Error updating supplier:', error);
      const errorMessage = error.message || 'Failed to update supplier';
      toast.error('Error', errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    closeModal('editSupplier');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      title={t('tooltips.suppliers.editSupplier')}
      size="xl"
      closeOnOverlayClick={!loading}
      closeOnEscape={!loading}
    >
      {editingSupplier ? (
        <SupplierForm
          supplier={editingSupplier}
          onSubmit={handleSubmit as any}
          onCancel={handleCancel}
          loading={loading}
        />
      ) : (
        <div className="p-4 text-center text-gray-500">
          {t('suppliers.noSupplierSelected')}
        </div>
      )}
    </Modal>
  );
};

export default EditSupplierModal;
